// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import ItemCard from '../components/itemCard';
// import CategoryCard from '../components/categoryCard/categoryCard';
// import ApiService from '../../services/apiService';
// import CashierBucket from '../components/cashierBucket';
// import CashierHistory from '../components/history';
// import { Form, useNavigate } from 'react-router-dom';
// import { ReactComponent as BackArrow } from '../../assets/images/svgIcons/LeftArrow.svg';
// import './cashierMenu.css';
// import Store from '../../assets/images/store1.png';
// import Shirt from '../../assets/images/pic.webp';
// import { FaSearch, FaBarcode, FaKeyboard, FaBox, FaStore, FaTags } from 'react-icons/fa';
// import { FaSquarePollVertical } from 'react-icons/fa6';
// import { HiOutlineSparkles, HiOutlineShoppingCart } from 'react-icons/hi';
// import { BiScan, BiGridAlt } from 'react-icons/bi';
// import { Button, Modal, Badge } from 'react-bootstrap';
// import MenuCard from '../../Customer/Menu/Menu Card/menuCard';
// import keyboard from '../../assets/images/keyboard.png';
// import { getCartData } from '../../../Redux/selecters';
// import { useSelector } from 'react-redux';
// import { useDispatch } from 'react-redux';
// import { AddToCart } from '../../../Redux/actions/cartAction';
// import { debounce } from 'lodash';
// import { toast } from 'react-toastify';

// function CashierMenu({ Currency }) {
//   const [activeView, setActiveView] = useState('Place Order');
//   const [menu, setMenu] = useState([]);
//   const [combo, setCombo] = useState([]);
//   const [Showitem, setShowItem] = useState(false);
//   const CurrencyData = useSelector((state) => state?.currency?.currency);
//   const [addsOns, setAddsOn] = useState([]);
//   const [cartItems, setCartItems] = useState([]);
//   const [isDisabled, setIsDisabled] = useState(false);
//   const [orders, setOrders] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [subCategories, setSubCategories] = useState([]);
//   const [selectedSubCategory, setSelectedSubCategory] = useState(null);
//   const [rowData, setRows] = useState();
//   const [show, setShow] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => {
//     setShow(true);
//   };
//   const [searchTerm, setSearchTerm] = useState('');
//   const [searchTerm1, setSearchTerm1] = useState('');
//   const [filteredItems, setFilteredItems] = useState([]);
//   const [brand, setBrand] = useState('');
//   const [department, setDepartment] = useState('');
//   const inputRef = useRef(null);
//   const [isSearchFocused, setIsSearchFocused] = useState(false);

//   // Stock state management
//   const [stockData, setStockData] = useState({});
//   const [isCheckingStock, setIsCheckingStock] = useState({});
//   const [stockLoadingForSearch, setStockLoadingForSearch] = useState(false);

//   // Fixed state variables for pagination
//   const [data, setData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize] = useState(25);
//   const [hasMoreItems, setHasMoreItems] = useState(true);
//   const [isLoadingMore, setIsLoadingMore] = useState(false);
//   const [initialLoading, setInitialLoading] = useState(false);

//   // Refs for infinite scroll
//   const gridContainerRef = useRef(null);
//   const observerRef = useRef(null);
//   const lastItemRef = useRef(null);

//   const cartData = useSelector(getCartData);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   // Check stock for a single item
//   const checkStockForItem = async (item) => {
//     const materialNo = item.itemNo || item.recordId || item.id;
//     if (!materialNo) return null;

//     try {
//       setIsCheckingStock((prev) => ({ ...prev, [materialNo]: true }));

//       const apiService = new ApiService();
//       const requestBody = {
//         request: {
//           endpointUrl: 'https://tp-apg-testza.multichoice.co.za/stock-processing-confirmation-api',
//           templateName: 'MaterialStockByLocationRequest',
//           CountryIdentifier: 'zaf',
//           Plant: '2402',
//           Material: materialNo.toString(),
//           token: await localStorage.getItem('Token'),
//         },
//       };

//       const response = await apiService.post('GET_MATERIAL_STOCK', requestBody);

//       if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {
//         const stockInfo = response.data.result;
//         setStockData((prev) => ({ ...prev, [materialNo]: stockInfo }));
//         return stockInfo;
//       } else {
//         console.error('Stock check failed for item:', materialNo);
//         setStockData((prev) => ({ ...prev, [materialNo]: { quantityNew: -1 } })); // -1 indicates unknown
//         return null;
//       }
//     } catch (error) {
//       console.error('Stock check error for item:', materialNo, error);
//       setStockData((prev) => ({ ...prev, [materialNo]: { quantityNew: -1 } }));
//       return null;
//     } finally {
//       setIsCheckingStock((prev) => ({ ...prev, [materialNo]: false }));
//     }
//   };

//   // Check stock for multiple items
//   const checkStockForMultipleItems = async (items) => {
//     if (!items || items.length === 0) return;

//     setStockLoadingForSearch(true);

//     // Check stock for each item in parallel
//     const stockPromises = items.map((item) => checkStockForItem(item));

//     try {
//       await Promise.all(stockPromises);
//     } catch (error) {
//       console.error('Error checking stock for multiple items:', error);
//     } finally {
//       setStockLoadingForSearch(false);
//     }
//   };

//   // Get stock status display
//   const getStockStatus = (item) => {
//     const materialNo = item.itemNo || item.recordId || item.id;
//     const stock = stockData[materialNo];
//     const isLoading = isCheckingStock[materialNo];

//     if (isLoading) {
//       return {
//         text: 'Checking stock...',
//         color: '#6c757d',
//         textColor: 'white',
//         available: true,
//       };
//     }

//     if (!stock) {
//       return {
//         text: 'Stock unknown',
//         color: '#6c757d',
//         textColor: 'white',
//         available: true, // Allow adding when stock is unknown
//       };
//     }

//     if (stock.quantityNew === -1) {
//       return {
//         text: 'Stock check failed',
//         color: '#6c757d',
//         textColor: 'white',
//         available: true, // Allow adding when check failed
//       };
//     }

//     if (stock.quantityNew <= 0) {
//       return {
//         text: 'Out of stock',
//         color: '#dc3545',
//         textColor: 'white',
//         available: false,
//       };
//     }

//     if (stock.quantityNew <= 5) {
//       return {
//         text: `Low stock (${stock.quantityNew} left)`,
//         color: '#ffc107',
//         textColor: '#000',
//         available: true,
//       };
//     }

//     return {
//       text: `In stock (${stock.quantityNew} available)`,
//       color: '#28a745',
//       textColor: 'white',
//       available: true,
//     };
//   };

//   useEffect(() => {
//     GetCategory();
//   }, [searchTerm]);

//   useEffect(() => {
//     GetMenu();
//     handleMenu();
//     if (selectedCategory) {
//       resetPagination();
//       GetMenu(1, false);
//       GetSubCategories(selectedCategory?.id);
//     }
//   }, [selectedCategory, isDisabled]);

//   const handleDisableToggle = (val) => {
//     setIsDisabled(val);
//   };

//   const GetOrders = async () => {
//     try {
//       const apiService = new ApiService();
//       let res = await apiService.get('GET_ORDERS');
//       const filteredOrders = res?.data?.result?.filter((item) => item?.active === true);
//       setOrders(filteredOrders);
//     } catch (error) {
//       console.error('Error fetching orders:', error);
//     }
//   };

//   const GetCategory = async () => {
//     try {
//       const apiService = new ApiService();
//       let parameters = `?Name=${searchTerm}`;
//       const res = await apiService.getApiParamater('GET_CATEGORY', parameters);
//       const filteredCategories = res?.data?.result?.filter((item) => item?.active === true);
//       setCategories(filteredCategories);
//     } catch (error) {
//       console.error('Error fetching AddsOn data:', error);
//     }
//   };

//   const GetSubCategories = async (categoryId) => {
//     try {
//       const apiService = new ApiService();
//       let parameters = `?CategoryId=${categoryId}`;
//       let res = await apiService.getApiParamater('GET_SUBCATEGORY', parameters);
//       if (res?.data?.statusCode == 204) {
//         setSubCategories('');
//       } else if (res?.data?.statusCode == 200) {
//         const filteredSubCategories = res?.data?.result?.filter((item) => item?.active === true);
//         setSubCategories(filteredSubCategories);
//       }
//     } catch (error) {
//       console.error('Error fetching sub-category data:', error);
//     }
//   };

//   // Fixed GetMenu function with proper pagination
//   const GetMenu = async (page = 1, isLoadMore = false) => {
//     try {
//       // Set loading states
//       if (isLoadMore) {
//         setIsLoadingMore(true);
//       } else if (page === 1) {
//         setInitialLoading(true);
//       }

//       const apiService = new ApiService();
//       let param = `?PageSize=${pageSize}&PageNumber=${page}`;
//       const res = await apiService.getApiParamater('GET_ITEM_QUICK', param);

//       if (res?.data?.statusCode === 200 || res?.data?.statusCode === 201) {
//         const newItems = res?.data?.result || [];

//         if (isLoadMore) {
//           // Append new items to existing data
//           setData((prevData) => [...prevData, ...newItems]);
//         } else {
//           // Replace data for initial load
//           setData(newItems);
//         }

//         // Update pagination state
//         setCurrentPage(page);

//         // Check if there are more items to load
//         // If we got fewer items than pageSize, we've reached the end
//         setHasMoreItems(newItems.length === pageSize);
//       } else {
//         // Handle case where no items are returned
//         if (!isLoadMore) {
//           setData([]);
//           setHasMoreItems(false);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching items:', error);
//       if (!isLoadMore) {
//         setData([]);
//         setHasMoreItems(false);
//       }
//     } finally {
//       if (isLoadMore) {
//         setIsLoadingMore(false);
//       } else if (page === 1) {
//         setInitialLoading(false);
//       }
//     }
//   };

//   // Fixed load more items function
//   const loadMoreItems = useCallback(() => {
//     if (!isLoadingMore && hasMoreItems) {
//       const nextPage = currentPage + 1;
//       console.log('Loading more items, page:', nextPage);
//       GetMenu(nextPage, true);
//     }
//   }, [currentPage, isLoadingMore, hasMoreItems]);

//   // Fixed intersection observer
//   const setupIntersectionObserver = useCallback(() => {
//     if (observerRef.current) {
//       observerRef.current.disconnect();
//     }

//     if (!lastItemRef.current || !hasMoreItems) return;

//     observerRef.current = new IntersectionObserver(
//       (entries) => {
//         const [entry] = entries;
//         if (entry.isIntersecting && hasMoreItems && !isLoadingMore) {
//           console.log('Intersection observer triggered, loading more items');
//           loadMoreItems();
//         }
//       },
//       {
//         root: gridContainerRef.current,
//         rootMargin: '100px',
//         threshold: 0.1,
//       }
//     );

//     observerRef.current.observe(lastItemRef.current);
//   }, [hasMoreItems, isLoadingMore, loadMoreItems]);

//   // Fixed manual scroll handler
//   const handleScroll = useCallback(
//     (e) => {
//       if (!hasMoreItems || isLoadingMore) return;

//       const { scrollTop, scrollHeight, clientHeight } = e.target;
//       const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;

//       // Load more when user scrolls to 85% of the content
//       if (scrollPercentage > 0.85) {
//         console.log('Manual scroll triggered, loading more items');
//         loadMoreItems();
//       }
//     },
//     [isLoadingMore, hasMoreItems, loadMoreItems]
//   );

//   // Reset pagination
//   const resetPagination = () => {
//     setCurrentPage(1);
//     setData([]);
//     setHasMoreItems(true);
//     setIsLoadingMore(false);
//     setInitialLoading(false);
//   };

//   // Setup intersection observer when data changes
//   useEffect(() => {
//     if (Showitem && data.length > 0) {
//       const timer = setTimeout(() => {
//         setupIntersectionObserver();
//       }, 100);
//       return () => clearTimeout(timer);
//     }
//     return () => {
//       if (observerRef.current) {
//         observerRef.current.disconnect();
//       }
//     };
//   }, [data.length, Showitem, setupIntersectionObserver]);

//   // Cleanup observer on unmount
//   useEffect(() => {
//     return () => {
//       if (observerRef.current) {
//         observerRef.current.disconnect();
//       }
//     };
//   }, []);

//   const GetMenuClick = (selectedCategory) => {
//     setSelectedCategory(selectedCategory);
//   };

//   const [selectedItem, setSelectedItem] = useState(null);

//   useEffect(() => {
//     if (inputRef.current) {
//       inputRef.current.focus();
//     }
//   }, [searchTerm, cartData, rowData, data, filteredItems]);

//   const debouncedSearch = debounce(async (value) => {
//     if (value.trim() === '') {
//       setFilteredItems([]);
//       return;
//     }

//     try {
//       const apiService = new ApiService();
//       // Changed from GET_MENU_R to GET_ITEM_MASTER with ItemName parameter
//       let param = `?ItemName=${encodeURIComponent(value)}`;
//       const response = await apiService.getApiParamater('GET_ITEM_MASTER', param);
//       const result = response?.data?.result || [];

//       // Check stock for all filtered items
//       await checkStockForMultipleItems(result);

//       // Check for exact barcode match first
//       const exactBarcodeMatch = result.find((item) => item.barcode && item.barcode.toLowerCase() === value.toLowerCase().trim());

//       if (exactBarcodeMatch) {
//         // Check stock before auto-adding
//         const stockStatus = getStockStatus(exactBarcodeMatch);
//         if (stockStatus.available) {
//           console.log('Exact barcode match found, adding to cart automatically:', exactBarcodeMatch);
//           handleItemSelect(exactBarcodeMatch);
//           setFilteredItems([]); // Clear dropdown
//         } else {
//           toast.error(`Item "${exactBarcodeMatch.itemDescription || exactBarcodeMatch.itemName}" is out of stock`);
//           setFilteredItems(result); // Show in dropdown with out of stock status
//         }
//         return;
//       }

//       // If no exact barcode match, show filtered results
//       setFilteredItems(result);
//     } catch (error) {
//       console.error('Search failed:', error);
//       setFilteredItems([]);
//     }
//   }, 300);

//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);

//     // Check if the input looks like a barcode (you can adjust this logic based on your barcode format)
//     const looksLikeBarcode = /^[0-9]{8,}$/.test(value.trim()); // Adjust regex as needed for your barcode format

//     if (looksLikeBarcode && value.length >= 8) {
//       // Minimum barcode length check
//       // For barcode-like inputs, search immediately without debounce
//       searchForExactBarcode(value);
//     } else {
//       // For text searches, use debounced search
//       debouncedSearch(value);
//     }
//   };

//   const searchForExactBarcode = async (barcode) => {
//     try {
//       const apiService = new ApiService();
//       // Changed to use GET_ITEM_MASTER with ItemName for barcode search
//       let param = `?ItemName=${encodeURIComponent(barcode.trim())}`;
//       const response = await apiService.getApiParamater('GET_ITEM_MASTER', param);
//       const result = response?.data?.result || [];

//       // Look for exact barcode match
//       const exactMatch = result.find((item) => item.barcode && item.barcode === barcode.trim());

//       if (exactMatch) {
//         // Check stock before adding
//         const stock = await checkStockForItem(exactMatch);
//         const stockStatus = getStockStatus(exactMatch);

//         if (stockStatus.available) {
//           console.log('Exact barcode match found:', exactMatch);
//           handleItemSelect(exactMatch);
//         } else {
//           toast.error(`Item "${exactMatch.itemDescription || exactMatch.itemName}" is out of stock`);
//           setFilteredItems([exactMatch]); // Show in dropdown with out of stock status
//         }
//       } else {
//         // If no exact match, fall back to regular search
//         debouncedSearch(barcode);
//       }
//     } catch (error) {
//       console.error('Barcode search failed:', error);
//       // Fall back to regular search on error
//       debouncedSearch(barcode);
//     }
//   };

//   const handleItemSelect = async (item) => {
//     // Check stock status before adding to cart
//     const stockStatus = getStockStatus(item);

//     if (!stockStatus.available) {
//       toast.error(`Item "${item.itemDescription || item.itemName}" is out of stock and cannot be added to cart`);
//       return;
//     }

//     setSelectedItem(item);

//     // Create the cart item data structure
//     const mergedData = {
//       id: item.itemNo || item.recordId || item.id,
//       name: item.itemDescription || item.itemName || item.name || 'Unnamed',
//       barcode: item.barcode,
//       quantity: 1,
//       price: item.salePrice || item.price || 0,
//       item: {
//         recordId: item.recordId || item.id || item.itemNo,
//         record_Id: item.recordId || item.id || item.itemNo,
//         itemName: item.itemDescription || item.itemName || item.name,
//         salePrice: item.salePrice || item.price || 0,
//         itemNo: item.itemNo || item.recordId || item.id,
//         barcode: item.barcode,
//         // Include other item properties that might be needed
//         brand: item.brand,
//         category: item.category,
//         stock: stockData[item.itemNo || item.recordId || item.id]?.quantityNew || 0,
//         vat: item.vat || item.taxRate,
//         taxRate: item.taxRate || item.vat,
//       },
//       stockData: stockData[item.itemNo || item.recordId || item.id], // Include stock data
//     };

//     // Add to Redux cart
//     dispatch(AddToCart(mergedData));

//     // Clear search state
//     setSearchTerm('');
//     setFilteredItems([]);

//     // Focus back to input for next scan/search
//     if (inputRef.current) {
//       inputRef.current.focus();
//     }

//     // Show success feedback
//     if (stockStatus.text.includes('Low stock')) {
//       toast.warning(`Added "${item.itemDescription || item.itemName}" to cart. ${stockStatus.text}`);
//     } else {
//       toast.success(`Added "${item.itemDescription || item.itemName}" to cart`);
//     }
//   };

//   // Enhanced handleKeyDown with better Enter key handling
//   const handleKeyDown = (event) => {
//     if (event.key === 'Enter') {
//       event.preventDefault();

//       const searchValue = searchTerm.trim();

//       if (filteredItems?.length > 0) {
//         // Check if first item is in stock before selecting
//         const firstItem = filteredItems[0];
//         const stockStatus = getStockStatus(firstItem);

//         if (stockStatus.available) {
//           handleItemSelect(firstItem);
//         } else {
//           toast.error(`First item "${firstItem.itemDescription || firstItem.itemName}" is out of stock`);
//         }
//       } else if (searchValue.length > 0) {
//         // If no dropdown items but there's a search value, try to search for exact match
//         const looksLikeBarcode = /^[0-9]{8,}$/.test(searchValue);

//         if (looksLikeBarcode) {
//           searchForExactBarcode(searchValue);
//         } else {
//           // For text searches, trigger immediate search
//           searchForExactItem(searchValue);
//         }
//       }
//     }
//   };

//   const searchForExactItem = async (searchValue) => {
//     try {
//       const apiService = new ApiService();
//       // Changed from GET_MENU_R to GET_ITEM_MASTER with ItemName
//       let param = `?ItemName=${encodeURIComponent(searchValue)}`;
//       const response = await apiService.getApiParamater('GET_ITEM_MASTER', param);
//       const result = response?.data?.result || [];

//       if (result.length > 0) {
//         // Check stock for the first item
//         const firstItem = result[0];
//         await checkStockForItem(firstItem);
//         const stockStatus = getStockStatus(firstItem);

//         if (stockStatus.available) {
//           handleItemSelect(firstItem);
//         } else {
//           toast.error(`Item "${firstItem.itemDescription || firstItem.itemName}" is out of stock`);
//         }
//       } else {
//         console.log('No items found for:', searchValue);
//         toast.warning('No items found');
//       }
//     } catch (error) {
//       console.error('Exact item search failed:', error);
//     }
//   };

//   const addToCart = (item) => {
//     const existingItem = cartItems?.find((cartItem) => cartItem?.id === item?.itemData?.id);

//     if (item?.addsOns) {
//       const addon = item.addsOns;
//       const existingAddon = cartItems?.find((cartItem) => cartItem?.id === addon.id);

//       if (existingAddon) {
//         const updatedCartItems = cartItems?.map((cartItem) => (cartItem.id === addon.id ? { ...cartItem, quantity: cartItem.quantity + 1 } : cartItem));
//         setCartItems(updatedCartItems);
//       } else {
//         setCartItems([...cartItems, { ...addon, quantity: 1 }]);
//       }
//     } else if (existingItem) {
//       const updatedCartItems = cartItems?.map((cartItem) => (cartItem.id === item?.itemData?.id ? { ...cartItem, quantity: cartItem.quantity + 1 } : cartItem));
//       setCartItems(updatedCartItems);
//     } else {
//       setCartItems([...cartItems, { ...item, quantity: 1 }]);
//     }
//   };

//   const handleMenu = async (sub) => {
//     try {
//       const apiService = new ApiService();
//       // If you want to get all items, you might pass an empty string or wildcard
//       let param = `?ItemName=`; // or however your API handles getting all items
//       let res = await apiService.getApiParamater('GET_ITEM_MASTER', param);

//       if (res?.data?.statusCode === 200) {
//         const filteredMenu = res?.data?.result;
//         setMenu(filteredMenu);
//       } else {
//         console.error('Error fetching menu by category:', res?.data?.message);
//       }
//     } catch (error) {
//       console.error('Error fetching menu by category:', error);
//     }
//   };

//   const removeFromCart = (index) => {
//     const newCartItems = [...cartItems];
//     newCartItems.splice(index, 1);
//     setCartItems(newCartItems);
//   };

//   const updateQuantity = (index, newQuantity) => {
//     const updatedCartItems = [...cartItems];
//     updatedCartItems[index].quantity = newQuantity;
//     setCartItems(updatedCartItems);
//   };

//   const handleQuick = () => {
//     setShowItem(!Showitem);
//     if (!Showitem) {
//       // When showing items, reset and load first page
//       resetPagination();
//       GetMenu(1, false);
//     }
//   };

//   const handleBack = () => {
//     setCombo([]);
//   };

//   // Enhanced styles with #6e5199 color scheme
//   const primaryColor = '#6e5199';
//   const primaryLight = '#8a7db8';
//   const primaryDark = '#5a4277';
//   const primaryVeryLight = '#f3f1f8';
//   const primaryUltraLight = '#faf9fc';

//   const containerStyle = {
//     background: `linear-gradient(135deg, ${primaryVeryLight} 0%, ${primaryUltraLight} 100%)`,
//     minHeight: '70vh',
//     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//   };

//   const searchContainerStyle = {
//     background: 'white',
//     borderRadius: '16px',
//     padding: '24px',
//     boxShadow: '0 4px 20px rgba(110, 81, 153, 0.1)',
//     border: `1px solid ${primaryVeryLight}`,
//     marginBottom: '24px',
//   };

//   const searchInputStyle = {
//     border: `2px solid ${isSearchFocused ? primaryColor : '#e9ecef'}`,
//     borderRadius: '12px',
//     padding: '16px 20px 16px 50px',
//     fontSize: '16px',
//     fontWeight: '500',
//     backgroundColor: isSearchFocused ? primaryUltraLight : '#f8f9fa',
//     transition: 'all 0.3s ease',
//     boxShadow: isSearchFocused ? `0 0 0 4px ${primaryColor}20` : 'none',
//     outline: 'none',
//   };

//   const quickKeysButtonStyle = {
//     background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryDark} 100%)`,
//     color: 'white',
//     border: 'none',
//     borderRadius: '12px',
//     padding: '12px 20px',
//     fontWeight: '600',
//     fontSize: '14px',
//     boxShadow: `0 4px 12px ${primaryColor}30`,
//     transition: 'all 0.3s ease',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//   };

//   const leftPanelStyle = {
//     background: 'white',
//     borderRadius: '20px',
//     padding: '0',
//     overflow: 'hidden',
//     boxShadow: '0 8px 32px rgba(110, 81, 153, 0.1)',
//     border: `1px solid ${primaryVeryLight}`,
//   };

//   const rightPanelStyle = {
//     background: `linear-gradient(135deg, ${primaryVeryLight} 0%, white 100%)`,
//     borderRadius: '20px',
//     padding: '30px',
//     minHeight: '70vh',
//     boxShadow: '0 8px 32px rgba(110, 81, 153, 0.15)',
//     border: `2px solid ${primaryColor}20`,
//   };

//   const dropdownStyle = {
//     background: 'white',
//     border: `1px solid ${primaryVeryLight}`,
//     borderRadius: '12px',
//     boxShadow: '0 8px 32px rgba(110, 81, 153, 0.2)',
//     zIndex: 1000,
//     maxHeight: '300px',
//     overflowY: 'auto',
//   };

//   const dropdownItemStyle = {
//     padding: '16px 20px',
//     borderBottom: `1px solid ${primaryVeryLight}`,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '14px',
//     fontWeight: '500',
//   };

//   const productDetailCardStyle = {
//     background: 'white',
//     borderRadius: '16px',
//     padding: '32px',
//     boxShadow: '0 4px 20px rgba(110, 81, 153, 0.1)',
//     border: `1px solid ${primaryVeryLight}`,
//     marginBottom: '24px',
//   };

//   const specCardStyle = {
//     background: primaryUltraLight,
//     borderRadius: '12px',
//     padding: '24px',
//     border: `1px solid ${primaryVeryLight}`,
//     marginTop: '24px',
//   };

//   const modalStyle = {
//     border: 'none',
//     borderRadius: '20px',
//     overflow: 'hidden',
//     boxShadow: '0 20px 60px rgba(110, 81, 153, 0.3)',
//   };

//   const tagStyle = {
//     background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryDark} 100%)`,
//     color: 'white',
//     padding: '6px 12px',
//     borderRadius: '20px',
//     fontSize: '12px',
//     fontWeight: '600',
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//   };

//   return (
//     <div style={containerStyle} className="pt-5 ">
//       <div className="row px-3 g-4">
//         {/* Left Panel - Enhanced */}
//         <div className="col-lg-6">
//           <div style={leftPanelStyle}>
//             {/* Enhanced Search Section */}
//             <div style={searchContainerStyle}>
//               <div className="row align-items-center">
//                 <div className="col-lg-8">
//                   <div className="position-relative">
//                     <input
//                       type="text"
//                       value={searchTerm}
//                       onChange={handleSearchChange}
//                       onKeyDown={handleKeyDown}
//                       onFocus={() => setIsSearchFocused(true)}
//                       onBlur={() => setTimeout(() => setIsSearchFocused(false), 200)}
//                       placeholder="Scan barcode or search by name, barcode, item number..."
//                       className="form-control"
//                       style={{
//                         ...searchInputStyle,
//                         paddingLeft: '50px',
//                         width: '100%',
//                       }}
//                       ref={inputRef}
//                       autoComplete="off"
//                       spellCheck="false"
//                     />

//                     {filteredItems?.length > 0 && (
//                       <div className="position-absolute w-100" style={{ top: '100%', zIndex: 1000 }}>
//                         <div style={dropdownStyle} className="mt-2">
//                           {/* Show a header if we have multiple results */}
//                           {filteredItems.length > 1 && (
//                             <div
//                               style={{
//                                 padding: '12px 20px',
//                                 backgroundColor: primaryVeryLight,
//                                 borderBottom: `1px solid ${primaryVeryLight}`,
//                                 fontSize: '12px',
//                                 fontWeight: '600',
//                                 color: primaryColor,
//                                 textTransform: 'uppercase',
//                                 letterSpacing: '0.5px',
//                               }}
//                             >
//                               Found {filteredItems.length} items - Click to select
//                               {stockLoadingForSearch && (
//                                 <span className="ms-2">
//                                   <span className="spinner-border spinner-border-sm" role="status">
//                                     <span className="visually-hidden">Checking stock...</span>
//                                   </span>
//                                 </span>
//                               )}
//                             </div>
//                           )}

//                           {filteredItems.map((item, index) => {
//                             const isExactBarcodeMatch = item.barcode && item.barcode.toLowerCase() === searchTerm.toLowerCase().trim();
//                             const stockStatus = getStockStatus(item);
//                             const materialNo = item.itemNo || item.recordId || item.id;
//                             const isLoadingStock = isCheckingStock[materialNo];

//                             return (
//                               <div
//                                 key={item.barcode || `item-${index}`}
//                                 style={{
//                                   ...dropdownItemStyle,
//                                   backgroundColor: isExactBarcodeMatch ? primaryUltraLight : 'white',
//                                   borderLeft: isExactBarcodeMatch ? `4px solid ${primaryColor}` : 'none',
//                                   opacity: !stockStatus.available ? 0.6 : 1,
//                                   cursor: stockStatus.available ? 'pointer' : 'not-allowed',
//                                 }}
//                                 onClick={() => stockStatus.available && handleItemSelect(item)}
//                                 onMouseEnter={(e) => {
//                                   if (stockStatus.available) {
//                                     e.target.style.backgroundColor = primaryUltraLight;
//                                     if (!isExactBarcodeMatch) {
//                                       e.target.style.borderLeftColor = primaryColor;
//                                       e.target.style.borderLeftWidth = '4px';
//                                     }
//                                   }
//                                 }}
//                                 onMouseLeave={(e) => {
//                                   if (stockStatus.available) {
//                                     if (!isExactBarcodeMatch) {
//                                       e.target.style.backgroundColor = 'white';
//                                       e.target.style.borderLeftWidth = '0';
//                                     } else {
//                                       e.target.style.backgroundColor = primaryUltraLight;
//                                     }
//                                   }
//                                 }}
//                               >
//                                 <div className="d-flex justify-content-between align-items-center">
//                                   <div style={{ flex: 1 }}>
//                                     <div
//                                       style={{
//                                         color: '#212529',
//                                         fontWeight: '600',
//                                         marginBottom: '4px',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '8px',
//                                       }}
//                                     >
//                                       {item.itemDescription || item.itemName}
//                                       {isExactBarcodeMatch && (
//                                         <span
//                                           style={{
//                                             backgroundColor: primaryColor,
//                                             color: 'white',
//                                             fontSize: '10px',
//                                             padding: '2px 6px',
//                                             borderRadius: '10px',
//                                             fontWeight: '600',
//                                             textTransform: 'uppercase',
//                                           }}
//                                         >
//                                           Exact Match
//                                         </span>
//                                       )}
//                                     </div>
//                                     <div className="d-flex align-items-center gap-2">
//                                       <span style={tagStyle}>
//                                         <FaBarcode size={10} />
//                                         {item.exp10 || item.barcode}
//                                       </span>
//                                       <span style={{ fontSize: '12px', color: '#6c757d' }}>
//                                         {Currency?.currency?.code}
//                                         {item.salePrice || item.price || '0.00'}
//                                       </span>
//                                       {/* Stock status badge */}
//                                       <span
//                                         style={{
//                                           fontSize: '11px',
//                                           backgroundColor: stockStatus.color,
//                                           color: stockStatus.textColor,
//                                           padding: '2px 8px',
//                                           borderRadius: '12px',
//                                           fontWeight: '600',
//                                           display: 'inline-flex',
//                                           alignItems: 'center',
//                                           gap: '4px',
//                                         }}
//                                       >
//                                         {isLoadingStock && (
//                                           <span className="spinner-border spinner-border-sm" role="status" style={{ width: '10px', height: '10px' }}>
//                                             <span className="visually-hidden">Loading...</span>
//                                           </span>
//                                         )}
//                                         {stockStatus.text}
//                                       </span>
//                                     </div>
//                                   </div>
//                                   <HiOutlineShoppingCart
//                                     color={stockStatus.available ? primaryColor : '#dc3545'}
//                                     size={18}
//                                     style={{ opacity: stockStatus.available ? 1 : 0.5 }}
//                                   />
//                                 </div>
//                                 {!stockStatus.available && (
//                                   <div style={{ fontSize: '11px', color: '#dc3545', marginTop: '4px', fontStyle: 'italic' }}>
//                                     This item cannot be added to cart
//                                   </div>
//                                 )}
//                               </div>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 <div className="col-lg-4">
//                   <div className="d-flex gap-3 align-items-center">
//                     <button
//                       style={{
//                         ...quickKeysButtonStyle,
//                         background: isSearchFocused ? primaryLight : quickKeysButtonStyle.background,
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = 'translateY(-2px)';
//                         e.target.style.boxShadow = `0 6px 20px ${primaryColor}40`;
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = 'translateY(0)';
//                         e.target.style.boxShadow = `0 4px 12px ${primaryColor}30`;
//                       }}
//                       onClick={() => {
//                         // Keyboard functionality
//                       }}
//                     >
//                       <FaKeyboard size={16} />
//                     </button>
//                     <button
//                       style={quickKeysButtonStyle}
//                       onClick={handleQuick}
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = 'translateY(-2px)';
//                         e.target.style.boxShadow = `0 6px 20px ${primaryColor}40`;
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = 'translateY(0)';
//                         e.target.style.boxShadow = `0 4px 12px ${primaryColor}30`;
//                       }}
//                     >
//                       <FaSquarePollVertical size={16} />
//                       Quick Keys
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Content Area */}
//             <div className="p-4">
//               {Showitem ? (
//                 <div className="grid-container">
//                   <div className="grid-header">
//                     <div className="d-flex justify-content-between align-items-center mb-4">
//                       <h5 style={{ color: primaryColor, fontWeight: '700', margin: 0 }}>
//                         <BiGridAlt className="me-2" />
//                         Quick Access Items
//                       </h5>
//                       <div className="d-flex align-items-center gap-3">
//                         <Badge
//                           bg="light"
//                           text="dark"
//                           style={{
//                             backgroundColor: primaryUltraLight,
//                             color: primaryColor,
//                             fontSize: '12px',
//                             fontWeight: '600',
//                           }}
//                         >
//                           {data?.length} items loaded
//                         </Badge>
//                         {(isLoadingMore || initialLoading) && (
//                           <div className="spinner-border spinner-border-sm text-primary" role="status">
//                             <span className="visually-hidden">Loading...</span>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="grid-content">
//                     {initialLoading ? (
//                       <div className="d-flex justify-content-center align-items-center py-5">
//                         <div className="spinner-border text-primary me-3" role="status">
//                           <span className="visually-hidden">Loading...</span>
//                         </div>
//                         <span>Loading items...</span>
//                       </div>
//                     ) : data.length === 0 ? (
//                       <div className="text-center py-5">
//                         <div
//                           style={{
//                             background: primaryUltraLight,
//                             borderRadius: '20px',
//                             padding: '40px',
//                             border: `2px dashed ${primaryColor}30`,
//                           }}
//                         >
//                           <FaStore size={64} color={primaryLight} className="mb-4" />
//                           <h5 style={{ color: primaryColor, fontWeight: '700', marginBottom: '8px' }}>No Items Found</h5>
//                           <p style={{ color: '#6c757d', margin: 0 }}>Try adjusting your search or category filters</p>
//                         </div>
//                       </div>
//                     ) : (
//                       <div
//                         ref={gridContainerRef}
//                         onScroll={handleScroll}
//                         style={{
//                           maxHeight: '60vh',
//                           overflowY: 'auto',
//                           overflowX: 'hidden',
//                         }}
//                       >
//                         <div className="CashierGrid">
//                           {data?.map((item, index) => (
//                             <div key={`${item.id || item.recordId || item.itemNo}-${index}`} ref={index === data.length - 1 ? lastItemRef : null}>
//                               <ItemCard val={item} addToCart={addToCart} />
//                             </div>
//                           ))}
//                         </div>

//                         {/* Loading indicator */}
//                         {isLoadingMore && (
//                           <div className="text-center py-4">
//                             <div className="d-flex justify-content-center align-items-center">
//                               <div className="spinner-border text-primary me-3" role="status" style={{ width: '1.5rem', height: '1.5rem' }}>
//                                 <span className="visually-hidden">Loading...</span>
//                               </div>
//                               <span style={{ fontSize: '14px', fontWeight: '500', color: primaryColor }}>Loading more items...</span>
//                             </div>
//                           </div>
//                         )}

//                         {/* End of items indicator */}
//                         {!hasMoreItems && data.length > 0 && !isLoadingMore && (
//                           <div className="text-center py-4">
//                             <div
//                               style={{
//                                 background: primaryUltraLight,
//                                 borderRadius: '12px',
//                                 padding: '16px',
//                                 border: `1px solid ${primaryVeryLight}`,
//                               }}
//                             >
//                               <p style={{ margin: 0, color: '#6c757d', fontWeight: '500', fontSize: '14px' }}>🎉 All items loaded ({data.length} total)</p>
//                             </div>
//                           </div>
//                         )}

//                         {/* Load More Button (fallback) */}
//                         {hasMoreItems && !isLoadingMore && data.length > 0 && (
//                           <div className="text-center py-3">
//                             <button
//                               onClick={loadMoreItems}
//                               className="btn"
//                               style={{
//                                 backgroundColor: primaryColor,
//                                 color: 'white',
//                                 border: 'none',
//                                 borderRadius: '8px',
//                                 padding: '10px 20px',
//                                 fontSize: '14px',
//                                 fontWeight: '600',
//                                 transition: 'all 0.2s ease',
//                               }}
//                               onMouseEnter={(e) => {
//                                 e.target.style.backgroundColor = primaryDark;
//                                 e.target.style.transform = 'translateY(-1px)';
//                               }}
//                               onMouseLeave={(e) => {
//                                 e.target.style.backgroundColor = primaryColor;
//                                 e.target.style.transform = 'translateY(0)';
//                               }}
//                             >
//                               Load More Items ({data.length} loaded)
//                             </button>
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               ) : rowData ? (
//                 <div style={productDetailCardStyle}>
//                   <div className="row align-items-center">
//                     {/* Enhanced Product Image */}
//                     <div className="col-md-5 text-center">
//                       <div
//                         style={{
//                           background: primaryUltraLight,
//                           borderRadius: '16px',
//                           padding: '20px',
//                           border: `2px dashed ${primaryColor}30`,
//                         }}
//                       >
//                         <img
//                           className="img-fluid rounded"
//                           src={Shirt}
//                           alt={rowData?.name || 'Product Image'}
//                           style={{ maxHeight: '300px', objectFit: 'cover' }}
//                         />
//                       </div>
//                     </div>

//                     {/* Enhanced Product Details */}
//                     <div className="col-md-7">
//                       <div className="d-flex align-items-center gap-2 mb-3">
//                         <HiOutlineSparkles color={primaryColor} size={24} />
//                         <h4 style={{ color: primaryColor, fontWeight: '700', margin: 0 }}>{rowData?.name || 'Product Details'}</h4>
//                       </div>

//                       <div className="row g-3">
//                         <div className="col-6">
//                           <div
//                             style={{
//                               background: primaryUltraLight,
//                               padding: '12px 16px',
//                               borderRadius: '8px',
//                               border: `1px solid ${primaryVeryLight}`,
//                             }}
//                           >
//                             <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600', marginBottom: '4px' }}>BARCODE</div>
//                             <div style={{ fontWeight: '700', color: primaryColor }}>{rowData?.barcode || 'N/A'}</div>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div
//                             style={{
//                               background: primaryUltraLight,
//                               padding: '12px 16px',
//                               borderRadius: '8px',
//                               border: `1px solid ${primaryVeryLight}`,
//                             }}
//                           >
//                             <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600', marginBottom: '4px' }}>ITEM NO</div>
//                             <div style={{ fontWeight: '700', color: primaryColor }}>{rowData?.item?.itemNo || 'N/A'}</div>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div
//                             style={{
//                               background: primaryUltraLight,
//                               padding: '12px 16px',
//                               borderRadius: '8px',
//                               border: `1px solid ${primaryVeryLight}`,
//                             }}
//                           >
//                             <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600', marginBottom: '4px' }}>PRICE</div>
//                             <div style={{ fontWeight: '700', color: '#28a745', fontSize: '18px' }}>${rowData?.price || '0.00'}</div>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div
//                             style={{
//                               background: primaryUltraLight,
//                               padding: '12px 16px',
//                               borderRadius: '8px',
//                               border: `1px solid ${primaryVeryLight}`,
//                             }}
//                           >
//                             <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600', marginBottom: '4px' }}>STOCK</div>
//                             <div style={{ fontWeight: '700', color: primaryColor }}>{rowData?.item?.stock || 'N/A'} units</div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Enhanced Specifications */}
//                   <div style={specCardStyle}>
//                     <h6 style={{ color: primaryColor, fontWeight: '700', marginBottom: '16px' }}>
//                       <FaTags className="me-2" />
//                       Product Specifications
//                     </h6>
//                     <div className="row g-3">
//                       <div className="col-md-4">
//                         <div style={{ marginBottom: '12px' }}>
//                           <span style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600' }}>Brand:</span>
//                           <div style={{ fontWeight: '600', color: '#212529' }}>{rowData?.item?.brand || 'N/A'}</div>
//                         </div>
//                       </div>
//                       <div className="col-md-4">
//                         <div style={{ marginBottom: '12px' }}>
//                           <span style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600' }}>Supplier:</span>
//                           <div style={{ fontWeight: '600', color: '#212529' }}>{rowData?.item?.supplier || 'N/A'}</div>
//                         </div>
//                       </div>
//                       <div className="col-md-4">
//                         <div style={{ marginBottom: '12px' }}>
//                           <span style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600' }}>Category:</span>
//                           <div style={{ fontWeight: '600', color: '#212529' }}>
//                             {rowData?.item?.category || 'N/A'} - {rowData?.subCategory || 'N/A'}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div className="text-center py-5">
//                   <div
//                     style={{
//                       background: primaryUltraLight,
//                       borderRadius: '20px',
//                       padding: '40px',
//                       border: `2px dashed ${primaryColor}30`,
//                     }}
//                   >
//                     <FaStore size={64} color={primaryLight} className="mb-4" />
//                     <h5 style={{ color: primaryColor, fontWeight: '700', marginBottom: '8px' }}>Welcome to POS Terminal</h5>
//                     <p style={{ color: '#6c757d', margin: 0 }}>Search for items or use Quick Keys to get started</p>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Right Panel - Enhanced */}
//         <div className="col-lg-6">
//           <div style={rightPanelStyle}>
//             {activeView === 'Place Order' && (
//               <CashierBucket
//                 cartItems={cartItems}
//                 handleDisableToggle={handleDisableToggle}
//                 removeFromCart={removeFromCart}
//                 updateQuantity={updateQuantity}
//                 Back={handleBack}
//                 onRowSelect={setRows}
//                 showSearch={handleShow}
//               />
//             )}
//             {activeView === 'History' && <CashierHistory val={orders} />}
//           </div>
//         </div>
//       </div>

//       {/* Enhanced Modal - keeping original styles */}
//       <Modal show={show} onHide={handleClose} size="lg" centered style={modalStyle}>
//         <Modal.Header
//           closeButton
//           style={{
//             background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryDark} 100%)`,
//             color: 'white',
//             border: 'none',
//           }}
//         >
//           <Modal.Title style={{ fontWeight: '700', display: 'flex', alignItems: 'center', gap: '12px' }}>
//             <FaSearch size={20} />
//             Advanced Item Search
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ padding: '32px' }}>
//           <div className="row g-4">
//             {/* Enhanced Filters */}
//             <div className="col-md-4">
//               <div
//                 style={{
//                   background: primaryUltraLight,
//                   borderRadius: '16px',
//                   padding: '24px',
//                   border: `1px solid ${primaryVeryLight}`,
//                   height: 'fit-content',
//                 }}
//               >
//                 <h6 style={{ color: primaryColor, fontWeight: '700', marginBottom: '20px' }}>
//                   <FaTags className="me-2" />
//                   Filters
//                 </h6>

//                 <div className="mb-4">
//                   <label style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>Brands</label>
//                   <select
//                     value={brand}
//                     onChange={(e) => setBrand(e.target.value)}
//                     className="form-select"
//                     style={{
//                       border: `1px solid ${primaryVeryLight}`,
//                       borderRadius: '8px',
//                       padding: '12px',
//                     }}
//                   >
//                     <option value="">Select Brand</option>
//                   </select>
//                 </div>

//                 <div className="mb-4">
//                   <label style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>Department</label>
//                   <select
//                     value={department}
//                     onChange={(e) => setDepartment(e.target.value)}
//                     className="form-select"
//                     style={{
//                       border: `1px solid ${primaryVeryLight}`,
//                       borderRadius: '8px',
//                       padding: '12px',
//                     }}
//                   >
//                     <option value="">Select Department</option>
//                   </select>
//                 </div>

//                 <button
//                   className="btn w-100"
//                   disabled
//                   style={{
//                     backgroundColor: '#e9ecef',
//                     color: '#6c757d',
//                     border: 'none',
//                     borderRadius: '8px',
//                     padding: '12px',
//                     fontWeight: '600',
//                   }}
//                 >
//                   Apply Filters
//                 </button>
//               </div>
//             </div>

//             {/* Enhanced Search Results */}
//             <div className="col-md-8">
//               <div
//                 style={{
//                   background: 'white',
//                   borderRadius: '16px',
//                   border: `1px solid ${primaryVeryLight}`,
//                   overflow: 'hidden',
//                 }}
//               >
//                 <div
//                   style={{
//                     background: primaryUltraLight,
//                     padding: '20px',
//                     borderBottom: `1px solid ${primaryVeryLight}`,
//                   }}
//                 >
//                   <div className="position-relative">
//                     <FaSearch className="position-absolute top-50 start-0 translate-middle-y ms-3" color={primaryColor} size={16} style={{ zIndex: 10 }} />
//                     <input
//                       type="text"
//                       placeholder="Search for products..."
//                       value={searchTerm}
//                       className="form-control"
//                       style={{
//                         paddingLeft: '45px',
//                         border: `2px solid ${primaryVeryLight}`,
//                         borderRadius: '12px',
//                         padding: '14px 20px 14px 45px',
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
//                   <table className="table table-hover mb-0">
//                     <thead style={{ backgroundColor: primaryVeryLight, position: 'sticky', top: 0, zIndex: 10 }}>
//                       <tr>
//                         <th style={{ padding: '16px', fontWeight: '700', color: primaryColor, border: 'none' }}>Item Name</th>
//                         <th style={{ padding: '16px', fontWeight: '700', color: primaryColor, border: 'none' }}>Availability</th>
//                         <th style={{ padding: '16px', fontWeight: '700', color: primaryColor, border: 'none' }}>Price</th>
//                         <th style={{ padding: '16px', fontWeight: '700', color: primaryColor, border: 'none' }}>Qty</th>
//                         <th style={{ padding: '16px', fontWeight: '700', color: primaryColor, border: 'none' }}></th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {filteredItems.length > 0 ? (
//                         filteredItems.map((item, index) => (
//                           <tr key={index} style={{ borderBottom: `1px solid ${primaryVeryLight}` }}>
//                             <td style={{ padding: '16px' }}>
//                               <div>
//                                 <div style={{ fontWeight: '600', color: '#212529' }}>{item.name}</div>
//                                 <small style={{ color: '#6c757d' }}>{item.barcode}</small>
//                               </div>
//                             </td>
//                             <td style={{ padding: '16px' }}>
//                               <Badge bg={item.availability === 'In Stock' ? 'success' : 'warning'} style={{ fontSize: '11px' }}>
//                                 {item.availability}
//                               </Badge>
//                             </td>
//                             <td style={{ padding: '16px', fontWeight: '700', color: primaryColor }}>${item.price}</td>
//                             <td style={{ padding: '16px' }}>
//                               <input
//                                 type="number"
//                                 min="1"
//                                 defaultValue="1"
//                                 className="form-control"
//                                 style={{
//                                   width: '80px',
//                                   border: `1px solid ${primaryVeryLight}`,
//                                   borderRadius: '6px',
//                                   textAlign: 'center',
//                                 }}
//                               />
//                             </td>
//                             <td style={{ padding: '16px' }}>
//                               <button
//                                 className="btn btn-sm"
//                                 style={{
//                                   backgroundColor: primaryColor,
//                                   color: 'white',
//                                   border: 'none',
//                                   borderRadius: '6px',
//                                   padding: '8px 16px',
//                                   fontWeight: '600',
//                                 }}
//                               >
//                                 Add
//                               </button>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td colSpan="5" className="text-center" style={{ padding: '40px', color: '#6c757d' }}>
//                             <FaBox size={32} color={primaryLight} className="mb-3" />
//                             <div>No items found</div>
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Modal.Body>
//         <Modal.Footer
//           style={{
//             background: primaryUltraLight,
//             border: 'none',
//             padding: '24px 32px',
//           }}
//         >
//           <Button
//             variant="light"
//             onClick={handleClose}
//             style={{
//               border: `1px solid ${primaryVeryLight}`,
//               borderRadius: '8px',
//               padding: '12px 24px',
//               fontWeight: '600',
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             style={{
//               backgroundColor: primaryColor,
//               border: 'none',
//               borderRadius: '8px',
//               padding: '12px 24px',
//               fontWeight: '600',
//             }}
//             disabled
//           >
//             Confirm Selection
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

// export default CashierMenu;

import React, { useState, useEffect, useRef, useCallback } from 'react';
import ItemCard from '../components/itemCard';
import CategoryCard from '../components/categoryCard/categoryCard';
import ApiService from '../../services/apiService';
import CashierBucket from '../components/cashierBucket';
import CashierHistory from '../components/history';
import { Form, useNavigate } from 'react-router-dom';
import { ReactComponent as BackArrow } from '../../assets/images/svgIcons/LeftArrow.svg';
import './cashierMenu.css';
import Store from '../../assets/images/store1.png';
import Shirt from '../../assets/images/pic.webp';
import { FaSearch, FaBarcode, FaKeyboard, FaBox, FaStore, FaTags } from 'react-icons/fa';
import { FaSquarePollVertical } from 'react-icons/fa6';
import { HiOutlineSparkles, HiOutlineShoppingCart } from 'react-icons/hi';
import { BiScan, BiGridAlt } from 'react-icons/bi';
import { Button, Modal, Badge } from 'react-bootstrap';
import MenuCard from '../../Customer/Menu/Menu Card/menuCard';
import keyboard from '../../assets/images/keyboard.png';
import { getCartData } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { AddToCart } from '../../../Redux/actions/cartAction';
import { debounce } from 'lodash';
import { toast } from 'react-toastify';
import CartModal from '../components/cartPopup'; // Import CartModal

function CashierMenu({ Currency }) {
  const [activeView, setActiveView] = useState('Place Order');
  const [menu, setMenu] = useState([]);
  const [combo, setCombo] = useState([]);
  const [Showitem, setShowItem] = useState(false);
  const CurrencyData = useSelector((state) => state?.currency?.currency);
  const [addsOns, setAddsOn] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [orders, setOrders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [rowData, setRows] = useState();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTerm1, setSearchTerm1] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  const [brand, setBrand] = useState('');
  const [department, setDepartment] = useState('');
  const inputRef = useRef(null);
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  // Cart Modal state
  const [showCartModal, setShowCartModal] = useState(false);
  const [selectedItemForCart, setSelectedItemForCart] = useState(null);

  // Fixed state variables for pagination
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(50);
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);

  // Refs for infinite scroll
  const gridContainerRef = useRef(null);
  const observerRef = useRef(null);
  const lastItemRef = useRef(null);

  const cartData = useSelector(getCartData);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Handle closing cart modal
  const handleCloseCartModal = (itemAdded) => {
    setShowCartModal(false);
    setSelectedItemForCart(null);
    if (itemAdded) {
      // Clear search after successful add
      setSearchTerm('');
      setFilteredItems([]);
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  };

  useEffect(() => {
    GetCategory();
  }, [searchTerm]);

  useEffect(() => {
    GetMenu();
    handleMenu();
    if (selectedCategory) {
      resetPagination();
      GetMenu(1, false);
      GetSubCategories(selectedCategory?.id);
    }
  }, [selectedCategory, isDisabled]);

  const handleDisableToggle = (val) => {
    setIsDisabled(val);
  };

  const GetOrders = async () => {
    try {
      const apiService = new ApiService();
      let res = await apiService.get('GET_ORDERS');
      const filteredOrders = res?.data?.result?.filter((item) => item?.active === true);
      setOrders(filteredOrders);
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  const GetCategory = async () => {
    try {
      const apiService = new ApiService();
      let parameters = `?Name=${searchTerm}`;
      const res = await apiService.getApiParamater('GET_CATEGORY', parameters);
      const filteredCategories = res?.data?.result?.filter((item) => item?.active === true);
      setCategories(filteredCategories);
    } catch (error) {
      console.error('Error fetching AddsOn data:', error);
    }
  };

  const GetSubCategories = async (categoryId) => {
    try {
      const apiService = new ApiService();
      let parameters = `?CategoryId=${categoryId}`;
      let res = await apiService.getApiParamater('GET_SUBCATEGORY', parameters);
      if (res?.data?.statusCode == 204) {
        setSubCategories('');
      } else if (res?.data?.statusCode == 200) {
        const filteredSubCategories = res?.data?.result?.filter((item) => item?.active === true);
        setSubCategories(filteredSubCategories);
      }
    } catch (error) {
      console.error('Error fetching sub-category data:', error);
    }
  };

  // Fixed GetMenu function with proper pagination
  const GetMenu = async (page = 1, isLoadMore = false) => {
    try {
      // Set loading states
      if (isLoadMore) {
        setIsLoadingMore(true);
      } else if (page === 1) {
        setInitialLoading(true);
      }

      const apiService = new ApiService();
      let param = `?PageSize=${pageSize}&PageNo=${page}`;
      const res = await apiService.getApiParamater('GET_ITEM_QUICK', param);

      if (res?.data?.statusCode === 200 || res?.data?.statusCode === 201) {
        const newItems = res?.data?.result || [];

        if (isLoadMore) {
          // Append new items to existing data
          setData((prevData) => [...prevData, ...newItems]);
        } else {
          // Replace data for initial load
          setData(newItems);
        }

        // Update pagination state
        setCurrentPage(page);

        // Check if there are more items to load
        // If we got fewer items than pageSize, we've reached the end
        setHasMoreItems(newItems.length === pageSize);
      } else {
        // Handle case where no items are returned
        if (!isLoadMore) {
          setData([]);
          setHasMoreItems(false);
        }
      }
    } catch (error) {
      console.error('Error fetching items:', error);
      if (!isLoadMore) {
        setData([]);
        setHasMoreItems(false);
      }
    } finally {
      if (isLoadMore) {
        setIsLoadingMore(false);
      } else if (page === 1) {
        setInitialLoading(false);
      }
    }
  };

  // Fixed load more items function
  const loadMoreItems = useCallback(() => {
    if (!isLoadingMore && hasMoreItems) {
      const nextPage = currentPage + 1;
      console.log('Loading more items, page:', nextPage);
      GetMenu(nextPage, true);
    }
  }, [currentPage, isLoadingMore, hasMoreItems]);

  // Fixed intersection observer
  const setupIntersectionObserver = useCallback(() => {
    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    if (!lastItemRef.current || !hasMoreItems) return;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && hasMoreItems && !isLoadingMore) {
          console.log('Intersection observer triggered, loading more items');
          loadMoreItems();
        }
      },
      {
        root: gridContainerRef.current,
        rootMargin: '100px',
        threshold: 0.1,
      }
    );

    observerRef.current.observe(lastItemRef.current);
  }, [hasMoreItems, isLoadingMore, loadMoreItems]);

  // Fixed manual scroll handler
  const handleScroll = useCallback(
    (e) => {
      if (!hasMoreItems || isLoadingMore) return;

      const { scrollTop, scrollHeight, clientHeight } = e.target;
      const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;

      // Load more when user scrolls to 85% of the content
      if (scrollPercentage > 0.85) {
        console.log('Manual scroll triggered, loading more items');
        loadMoreItems();
      }
    },
    [isLoadingMore, hasMoreItems, loadMoreItems]
  );

  // Reset pagination
  const resetPagination = () => {
    setCurrentPage(1);
    setData([]);
    setHasMoreItems(true);
    setIsLoadingMore(false);
    setInitialLoading(false);
  };

  // Setup intersection observer when data changes
  useEffect(() => {
    if (Showitem && data.length > 0) {
      const timer = setTimeout(() => {
        setupIntersectionObserver();
      }, 100);
      return () => clearTimeout(timer);
    }
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [data.length, Showitem, setupIntersectionObserver]);

  // Cleanup observer on unmount
  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const GetMenuClick = (selectedCategory) => {
    setSelectedCategory(selectedCategory);
  };

  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [searchTerm, cartData, rowData, data, filteredItems]);

  const debouncedSearch = debounce(async (value) => {
    if (value.trim() === '') {
      setFilteredItems([]);
      return;
    }

    try {
      const apiService = new ApiService();
      let param = `?ItemName=${encodeURIComponent(value)}`;
      const response = await apiService.getApiParamater('GET_ITEM_MASTER', param);
      const result = response?.data?.result || [];

      // Check for exact barcode match first
      const exactBarcodeMatch = result.find((item) => item.barcode && item.barcode.toLowerCase() === value.toLowerCase().trim());

      if (exactBarcodeMatch) {
        // Auto-open cart modal for exact barcode match
        console.log('Exact barcode match found, opening cart modal:', exactBarcodeMatch);
        handleItemSelect(exactBarcodeMatch);
        setFilteredItems([]); // Clear dropdown
        return;
      }

      // If no exact barcode match, show filtered results
      setFilteredItems(result);
    } catch (error) {
      console.error('Search failed:', error);
      setFilteredItems([]);
    }
  }, 300);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Check if the input looks like a barcode (you can adjust this logic based on your barcode format)
    const looksLikeBarcode = /^[0-9]{8,}$/.test(value.trim()); // Adjust regex as needed for your barcode format

    if (looksLikeBarcode && value.length >= 8) {
      // Minimum barcode length check
      // For barcode-like inputs, search immediately without debounce
      searchForExactBarcode(value);
    } else {
      // For text searches, use debounced search
      debouncedSearch(value);
    }
  };

  const searchForExactBarcode = async (barcode) => {
    try {
      const apiService = new ApiService();
      let param = `?ItemName=${encodeURIComponent(barcode.trim())}`;
      const response = await apiService.getApiParamater('GET_ITEM_MASTER', param);
      const result = response?.data?.result || [];

      // Look for exact barcode match
      const exactMatch = result.find((item) => item.barcode && item.barcode === barcode.trim());

      if (exactMatch) {
        console.log('Exact barcode match found:', exactMatch);
        handleItemSelect(exactMatch);
      } else {
        // If no exact match, fall back to regular search
        debouncedSearch(barcode);
      }
    } catch (error) {
      console.error('Barcode search failed:', error);
      // Fall back to regular search on error
      debouncedSearch(barcode);
    }
  };

  const handleItemSelect = (item) => {
    // Open Cart Modal instead of directly adding to cart
    setSelectedItemForCart(item);
    setShowCartModal(true);
    setFilteredItems([]); // Clear dropdown
    setSearchTerm(''); // Clear search
  };

  // Enhanced handleKeyDown with better Enter key handling
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();

      const searchValue = searchTerm.trim();

      if (filteredItems?.length > 0) {
        // Select the first item and open cart modal
        const firstItem = filteredItems[0];
        handleItemSelect(firstItem);
      } else if (searchValue.length > 0) {
        // If no dropdown items but there's a search value, try to search for exact match
        const looksLikeBarcode = /^[0-9]{8,}$/.test(searchValue);

        if (looksLikeBarcode) {
          searchForExactBarcode(searchValue);
        } else {
          // For text searches, trigger immediate search
          searchForExactItem(searchValue);
        }
      }
    }
  };

  const searchForExactItem = async (searchValue) => {
    try {
      const apiService = new ApiService();
      let param = `?ItemName=${encodeURIComponent(searchValue)}`;
      const response = await apiService.getApiParamater('GET_ITEM_MASTER', param);
      const result = response?.data?.result || [];

      if (result.length > 0) {
        // Open cart modal for the first item
        const firstItem = result[0];
        handleItemSelect(firstItem);
      } else {
        console.log('No items found for:', searchValue);
        toast.warning('No items found');
      }
    } catch (error) {
      console.error('Exact item search failed:', error);
    }
  };

  const addToCart = (item) => {
    const existingItem = cartItems?.find((cartItem) => cartItem?.id === item?.itemData?.id);

    if (item?.addsOns) {
      const addon = item.addsOns;
      const existingAddon = cartItems?.find((cartItem) => cartItem?.id === addon.id);

      if (existingAddon) {
        const updatedCartItems = cartItems?.map((cartItem) => (cartItem.id === addon.id ? { ...cartItem, quantity: cartItem.quantity + 1 } : cartItem));
        setCartItems(updatedCartItems);
      } else {
        setCartItems([...cartItems, { ...addon, quantity: 1 }]);
      }
    } else if (existingItem) {
      const updatedCartItems = cartItems?.map((cartItem) => (cartItem.id === item?.itemData?.id ? { ...cartItem, quantity: cartItem.quantity + 1 } : cartItem));
      setCartItems(updatedCartItems);
    } else {
      setCartItems([...cartItems, { ...item, quantity: 1 }]);
    }
  };

  const handleMenu = async (sub) => {
    try {
      const apiService = new ApiService();
      // If you want to get all items, you might pass an empty string or wildcard
      let param = `?ItemName=`; // or however your API handles getting all items
      let res = await apiService.getApiParamater('GET_ITEM_MASTER', param);

      if (res?.data?.statusCode === 200) {
        const filteredMenu = res?.data?.result;
        setMenu(filteredMenu);
      } else {
        console.error('Error fetching menu by category:', res?.data?.message);
      }
    } catch (error) {
      console.error('Error fetching menu by category:', error);
    }
  };

  const removeFromCart = (index) => {
    const newCartItems = [...cartItems];
    newCartItems.splice(index, 1);
    setCartItems(newCartItems);
  };

  const updateQuantity = (index, newQuantity) => {
    const updatedCartItems = [...cartItems];
    updatedCartItems[index].quantity = newQuantity;
    setCartItems(updatedCartItems);
  };

  const handleQuick = () => {
    setShowItem(!Showitem);
    if (!Showitem) {
      // When showing items, reset and load first page
      resetPagination();
      GetMenu(1, false);
    }
  };

  const handleBack = () => {
    setCombo([]);
  };

  // Enhanced styles with #6e5199 color scheme
  const primaryColor = '#6e5199';
  const primaryLight = '#8a7db8';
  const primaryDark = '#5a4277';
  const primaryVeryLight = '#f3f1f8';
  const primaryUltraLight = '#faf9fc';

  const containerStyle = {
    background: `linear-gradient(135deg, ${primaryVeryLight} 0%, ${primaryUltraLight} 100%)`,
    minHeight: '70vh',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };

  const searchContainerStyle = {
    background: 'white',
    borderRadius: '16px',
    padding: '24px',
    boxShadow: '0 4px 20px rgba(110, 81, 153, 0.1)',
    border: `1px solid ${primaryVeryLight}`,
    marginBottom: '24px',
  };

  const searchInputStyle = {
    border: `2px solid ${isSearchFocused ? primaryColor : '#e9ecef'}`,
    borderRadius: '12px',
    padding: '16px 20px 16px 50px',
    fontSize: '16px',
    fontWeight: '500',
    backgroundColor: isSearchFocused ? primaryUltraLight : '#f8f9fa',
    transition: 'all 0.3s ease',
    boxShadow: isSearchFocused ? `0 0 0 4px ${primaryColor}20` : 'none',
    outline: 'none',
  };

  const quickKeysButtonStyle = {
    background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryDark} 100%)`,
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    padding: '12px 20px',
    fontWeight: '600',
    fontSize: '14px',
    boxShadow: `0 4px 12px ${primaryColor}30`,
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  };

  const leftPanelStyle = {
    background: 'white',
    borderRadius: '20px',
    padding: '0',
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(110, 81, 153, 0.1)',
    border: `1px solid ${primaryVeryLight}`,
  };

  const rightPanelStyle = {
    background: `linear-gradient(135deg, ${primaryVeryLight} 0%, white 100%)`,
    borderRadius: '20px',
    padding: '30px',
    minHeight: '70vh',
    boxShadow: '0 8px 32px rgba(110, 81, 153, 0.15)',
    border: `2px solid ${primaryColor}20`,
  };

  const dropdownStyle = {
    background: 'white',
    border: `1px solid ${primaryVeryLight}`,
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(110, 81, 153, 0.2)',
    zIndex: 1000,
    maxHeight: '300px',
    overflowY: 'auto',
  };

  const dropdownItemStyle = {
    padding: '16px 20px',
    borderBottom: `1px solid ${primaryVeryLight}`,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '14px',
    fontWeight: '500',
  };

  const productDetailCardStyle = {
    background: 'white',
    borderRadius: '16px',
    padding: '32px',
    boxShadow: '0 4px 20px rgba(110, 81, 153, 0.1)',
    border: `1px solid ${primaryVeryLight}`,
    marginBottom: '24px',
  };

  const specCardStyle = {
    background: primaryUltraLight,
    borderRadius: '12px',
    padding: '24px',
    border: `1px solid ${primaryVeryLight}`,
    marginTop: '24px',
  };

  const modalStyle = {
    border: 'none',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(110, 81, 153, 0.3)',
  };

  const tagStyle = {
    background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryDark} 100%)`,
    color: 'white',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  };

  return (
    <div style={containerStyle} className="pt-5 ">
      <div className="row px-3 g-4">
        {/* Left Panel - Enhanced */}
        <div className="col-lg-6">
          <div style={leftPanelStyle}>
            {/* Enhanced Search Section */}
            <div style={searchContainerStyle}>
              <div className="row align-items-center">
                <div className="col-lg-8">
                  <div className="position-relative">
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      onKeyDown={handleKeyDown}
                      onFocus={() => setIsSearchFocused(true)}
                      onBlur={() => setTimeout(() => setIsSearchFocused(false), 200)}
                      placeholder="Scan barcode or search by name, barcode, item number..."
                      className="form-control"
                      style={{
                        ...searchInputStyle,
                        paddingLeft: '50px',
                        width: '100%',
                      }}
                      ref={inputRef}
                      autoComplete="off"
                      spellCheck="false"
                    />

                    {filteredItems?.length > 0 && (
                      <div className="position-absolute w-100" style={{ top: '100%', zIndex: 1000 }}>
                        <div style={dropdownStyle} className="mt-2">
                          {/* Show a header if we have multiple results */}
                          {filteredItems.length > 1 && (
                            <div
                              style={{
                                padding: '12px 20px',
                                backgroundColor: primaryVeryLight,
                                borderBottom: `1px solid ${primaryVeryLight}`,
                                fontSize: '12px',
                                fontWeight: '600',
                                color: primaryColor,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                              }}
                            >
                              Found {filteredItems.length} items - Click to select
                            </div>
                          )}

                          {filteredItems.map((item, index) => {
                            const isExactBarcodeMatch = item.barcode && item.barcode.toLowerCase() === searchTerm.toLowerCase().trim();

                            return (
                              <div
                                key={item.barcode || `item-${index}`}
                                style={{
                                  ...dropdownItemStyle,
                                  backgroundColor: isExactBarcodeMatch ? primaryUltraLight : 'white',
                                  borderLeft: isExactBarcodeMatch ? `4px solid ${primaryColor}` : 'none',
                                }}
                                onClick={() => handleItemSelect(item)}
                                onMouseEnter={(e) => {
                                  e.target.style.backgroundColor = primaryUltraLight;
                                  if (!isExactBarcodeMatch) {
                                    e.target.style.borderLeftColor = primaryColor;
                                    e.target.style.borderLeftWidth = '4px';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!isExactBarcodeMatch) {
                                    e.target.style.backgroundColor = 'white';
                                    e.target.style.borderLeftWidth = '0';
                                  } else {
                                    e.target.style.backgroundColor = primaryUltraLight;
                                  }
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <div style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        color: '#212529',
                                        fontWeight: '600',
                                        marginBottom: '4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                      }}
                                    >
                                      {item.itemDescription || item.itemName}
                                      {isExactBarcodeMatch && (
                                        <span
                                          style={{
                                            backgroundColor: primaryColor,
                                            color: 'white',
                                            fontSize: '10px',
                                            padding: '2px 6px',
                                            borderRadius: '10px',
                                            fontWeight: '600',
                                            textTransform: 'uppercase',
                                          }}
                                        >
                                          Exact Match
                                        </span>
                                      )}
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                      <span style={tagStyle}>
                                        <FaBarcode size={10} />
                                        {item.exp10 || item.barcode}
                                      </span>
                                      <span style={{ fontSize: '12px', color: '#6c757d' }}>
                                        {Currency?.currency?.code}
                                        {item.salePrice || item.price || '0.00'}
                                      </span>
                                    </div>
                                  </div>
                                  <HiOutlineShoppingCart color={primaryColor} size={18} />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="d-flex gap-3 align-items-center">
                    <button
                      style={{
                        ...quickKeysButtonStyle,
                        background: isSearchFocused ? primaryLight : quickKeysButtonStyle.background,
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = `0 6px 20px ${primaryColor}40`;
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = `0 4px 12px ${primaryColor}30`;
                      }}
                      onClick={() => {
                        // Keyboard functionality
                      }}
                    >
                      <FaKeyboard size={16} />
                    </button>
                    <button
                      style={quickKeysButtonStyle}
                      onClick={handleQuick}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = `0 6px 20px ${primaryColor}40`;
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = `0 4px 12px ${primaryColor}30`;
                      }}
                    >
                      <FaSquarePollVertical size={16} />
                      Quick Keys
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Content Area */}
            <div className="p-4">
              {Showitem ? (
                <div className="grid-container">
                  <div className="grid-header">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 style={{ color: primaryColor, fontWeight: '700', margin: 0 }}>
                        <BiGridAlt className="me-2" />
                        Quick Access Items
                      </h5>
                      <div className="d-flex align-items-center gap-3">
                        <Badge
                          bg="light"
                          text="dark"
                          style={{
                            backgroundColor: primaryUltraLight,
                            color: primaryColor,
                            fontSize: '12px',
                            fontWeight: '600',
                          }}
                        >
                          {data?.length} items loaded
                        </Badge>
                        {(isLoadingMore || initialLoading) && (
                          <div className="spinner-border spinner-border-sm text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="grid-content">
                    {initialLoading ? (
                      <div className="d-flex justify-content-center align-items-center py-5">
                        <div className="spinner-border text-primary me-3" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <span>Loading items...</span>
                      </div>
                    ) : data.length === 0 ? (
                      <div className="text-center py-5">
                        <div
                          style={{
                            background: primaryUltraLight,
                            borderRadius: '20px',
                            padding: '40px',
                            border: `2px dashed ${primaryColor}30`,
                          }}
                        >
                          <FaStore size={64} color={primaryLight} className="mb-4" />
                          <h5 style={{ color: primaryColor, fontWeight: '700', marginBottom: '8px' }}>No Items Found</h5>
                          <p style={{ color: '#6c757d', margin: 0 }}>Try adjusting your search or category filters</p>
                        </div>
                      </div>
                    ) : (
                      <div
                        ref={gridContainerRef}
                        onScroll={handleScroll}
                        style={{
                          maxHeight: '60vh',
                          overflowY: 'auto',
                          overflowX: 'hidden',
                        }}
                      >
                        <div className="CashierGrid">
                          {data?.map((item, index) => (
                            <div key={`${item.id || item.recordId || item.itemNo}-${index}`} ref={index === data.length - 1 ? lastItemRef : null}>
                              <ItemCard val={item} addToCart={addToCart} />
                            </div>
                          ))}
                        </div>

                        {/* Loading indicator */}
                        {isLoadingMore && (
                          <div className="text-center py-4">
                            <div className="d-flex justify-content-center align-items-center">
                              <div className="spinner-border text-primary me-3" role="status" style={{ width: '1.5rem', height: '1.5rem' }}>
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              <span style={{ fontSize: '14px', fontWeight: '500', color: primaryColor }}>Loading more items...</span>
                            </div>
                          </div>
                        )}

                        {/* End of items indicator */}
                        {!hasMoreItems && data.length > 0 && !isLoadingMore && (
                          <div className="text-center py-4">
                            <div
                              style={{
                                background: primaryUltraLight,
                                borderRadius: '12px',
                                padding: '16px',
                                border: `1px solid ${primaryVeryLight}`,
                              }}
                            >
                              <p style={{ margin: 0, color: '#6c757d', fontWeight: '500', fontSize: '14px' }}>🎉 All items loaded ({data.length} total)</p>
                            </div>
                          </div>
                        )}

                        {/* Load More Button (fallback) */}
                        {hasMoreItems && !isLoadingMore && data.length > 0 && (
                          <div className="text-center py-3">
                            <button
                              onClick={loadMoreItems}
                              className="btn"
                              style={{
                                backgroundColor: primaryColor,
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '10px 20px',
                                fontSize: '14px',
                                fontWeight: '600',
                                transition: 'all 0.2s ease',
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = primaryDark;
                                e.target.style.transform = 'translateY(-1px)';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = primaryColor;
                                e.target.style.transform = 'translateY(0)';
                              }}
                            >
                              Load More Items ({data.length} loaded)
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ) : rowData ? (
                <div style={productDetailCardStyle}>
                  <div className="row align-items-center">
                    {/* Enhanced Product Image */}
                    <div className="col-md-5 text-center">
                      <div
                        style={{
                          background: primaryUltraLight,
                          borderRadius: '16px',
                          padding: '20px',
                          border: `2px dashed ${primaryColor}30`,
                        }}
                      >
                        <img
                          className="img-fluid rounded"
                          src={Shirt}
                          alt={rowData?.name || 'Product Image'}
                          style={{ maxHeight: '300px', objectFit: 'cover' }}
                        />
                      </div>
                    </div>

                    {/* Enhanced Product Details */}
                    <div className="col-md-7">
                      <div className="d-flex align-items-center gap-2 mb-3">
                        <HiOutlineSparkles color={primaryColor} size={24} />
                        <h4 style={{ color: primaryColor, fontWeight: '700', margin: 0 }}>{rowData?.name || 'Product Details'}</h4>
                      </div>

                      <div className="row g-3">
                        <div className="col-6">
                          <div
                            style={{
                              background: primaryUltraLight,
                              padding: '12px 16px',
                              borderRadius: '8px',
                              border: `1px solid ${primaryVeryLight}`,
                            }}
                          >
                            <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600', marginBottom: '4px' }}>BARCODE</div>
                            <div style={{ fontWeight: '700', color: primaryColor }}>{rowData?.barcode || 'N/A'}</div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div
                            style={{
                              background: primaryUltraLight,
                              padding: '12px 16px',
                              borderRadius: '8px',
                              border: `1px solid ${primaryVeryLight}`,
                            }}
                          >
                            <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600', marginBottom: '4px' }}>ITEM NO</div>
                            <div style={{ fontWeight: '700', color: primaryColor }}>{rowData?.item?.itemNo || 'N/A'}</div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div
                            style={{
                              background: primaryUltraLight,
                              padding: '12px 16px',
                              borderRadius: '8px',
                              border: `1px solid ${primaryVeryLight}`,
                            }}
                          >
                            <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600', marginBottom: '4px' }}>PRICE</div>
                            <div style={{ fontWeight: '700', color: '#28a745', fontSize: '18px' }}>${rowData?.price || '0.00'}</div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div
                            style={{
                              background: primaryUltraLight,
                              padding: '12px 16px',
                              borderRadius: '8px',
                              border: `1px solid ${primaryVeryLight}`,
                            }}
                          >
                            <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600', marginBottom: '4px' }}>STOCK</div>
                            <div style={{ fontWeight: '700', color: primaryColor }}>{rowData?.item?.stock || 'N/A'} units</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Enhanced Specifications */}
                  <div style={specCardStyle}>
                    <h6 style={{ color: primaryColor, fontWeight: '700', marginBottom: '16px' }}>
                      <FaTags className="me-2" />
                      Product Specifications
                    </h6>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <div style={{ marginBottom: '12px' }}>
                          <span style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600' }}>Brand:</span>
                          <div style={{ fontWeight: '600', color: '#212529' }}>{rowData?.item?.brand || 'N/A'}</div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div style={{ marginBottom: '12px' }}>
                          <span style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600' }}>Supplier:</span>
                          <div style={{ fontWeight: '600', color: '#212529' }}>{rowData?.item?.supplier || 'N/A'}</div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div style={{ marginBottom: '12px' }}>
                          <span style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600' }}>Category:</span>
                          <div style={{ fontWeight: '600', color: '#212529' }}>
                            {rowData?.item?.category || 'N/A'} - {rowData?.subCategory || 'N/A'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-5">
                  <div
                    style={{
                      background: primaryUltraLight,
                      borderRadius: '20px',
                      padding: '40px',
                      border: `2px dashed ${primaryColor}30`,
                    }}
                  >
                    <FaStore size={64} color={primaryLight} className="mb-4" />
                    <h5 style={{ color: primaryColor, fontWeight: '700', marginBottom: '8px' }}>Welcome to POS Terminal</h5>
                    <p style={{ color: '#6c757d', margin: 0 }}>Search for items or use Quick Keys to get started</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right Panel - Enhanced */}
        <div className="col-lg-6">
          <div style={rightPanelStyle}>
            {activeView === 'Place Order' && (
              <CashierBucket
                cartItems={cartItems}
                handleDisableToggle={handleDisableToggle}
                removeFromCart={removeFromCart}
                updateQuantity={updateQuantity}
                Back={handleBack}
                onRowSelect={setRows}
                showSearch={handleShow}
                Currency={Currency}
              />
            )}
            {activeView === 'History' && <CashierHistory val={orders} />}
          </div>
        </div>
      </div>

      {/* Cart Modal for item selection */}
      {showCartModal && selectedItemForCart && (
        <Modal show={showCartModal} onHide={() => handleCloseCartModal(false)} size="lg" centered>
          {/* <Modal.Header closeButton>
            <Modal.Title>Add to Cart</Modal.Title>
          </Modal.Header> */}
          <Modal.Body>
            <CartModal
              CartValue={{
                ...selectedItemForCart,
                record_Id: selectedItemForCart.recordId,
                itemName: selectedItemForCart.itemDescription,
                itemMasterVarients: selectedItemForCart.itemMasterVarients ||
                  selectedItemForCart.itemMasterDetails || [
                    {
                      recordId: selectedItemForCart.recordId,
                      itemNo: selectedItemForCart.itemNo,
                      itemDescription: selectedItemForCart.itemDescription,
                      salePrice: selectedItemForCart.salePrice || selectedItemForCart.purchasePrice || 0,
                      barcode: selectedItemForCart.barcode || selectedItemForCart.exp10,
                      vat: selectedItemForCart.vat || 0,
                    },
                  ],
                barcode: selectedItemForCart.barcode || selectedItemForCart.exp10,
                taxRate: selectedItemForCart.vat || 0,
              }}
              closeModal={handleCloseCartModal}
              isEdit={false}
              editingItem={null}
              Currency={Currency}
            />
          </Modal.Body>
        </Modal>
      )}

      {/* Enhanced Modal - keeping original styles */}
      <Modal show={show} onHide={handleClose} size="lg" centered style={modalStyle}>
        <Modal.Header
          closeButton
          style={{
            background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryDark} 100%)`,
            color: 'white',
            border: 'none',
          }}
        >
          <Modal.Title style={{ fontWeight: '700', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <FaSearch size={20} />
            Advanced Item Search
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '32px' }}>
          <div className="row g-4">
            {/* Enhanced Filters */}
            <div className="col-md-4">
              <div
                style={{
                  background: primaryUltraLight,
                  borderRadius: '16px',
                  padding: '24px',
                  border: `1px solid ${primaryVeryLight}`,
                  height: 'fit-content',
                }}
              >
                <h6 style={{ color: primaryColor, fontWeight: '700', marginBottom: '20px' }}>
                  <FaTags className="me-2" />
                  Filters
                </h6>

                <div className="mb-4">
                  <label style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>Brands</label>
                  <select
                    value={brand}
                    onChange={(e) => setBrand(e.target.value)}
                    className="form-select"
                    style={{
                      border: `1px solid ${primaryVeryLight}`,
                      borderRadius: '8px',
                      padding: '12px',
                    }}
                  >
                    <option value="">Select Brand</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>Department</label>
                  <select
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                    className="form-select"
                    style={{
                      border: `1px solid ${primaryVeryLight}`,
                      borderRadius: '8px',
                      padding: '12px',
                    }}
                  >
                    <option value="">Select Department</option>
                  </select>
                </div>

                <button
                  className="btn w-100"
                  disabled
                  style={{
                    backgroundColor: '#e9ecef',
                    color: '#6c757d',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px',
                    fontWeight: '600',
                  }}
                >
                  Apply Filters
                </button>
              </div>
            </div>

            {/* Enhanced Search Results */}
            <div className="col-md-8">
              <div
                style={{
                  background: 'white',
                  borderRadius: '16px',
                  border: `1px solid ${primaryVeryLight}`,
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    background: primaryUltraLight,
                    padding: '20px',
                    borderBottom: `1px solid ${primaryVeryLight}`,
                  }}
                >
                  <div className="position-relative">
                    <FaSearch className="position-absolute top-50 start-0 translate-middle-y ms-3" color={primaryColor} size={16} style={{ zIndex: 10 }} />
                    <input
                      type="text"
                      placeholder="Search for products..."
                      value={searchTerm}
                      className="form-control"
                      style={{
                        paddingLeft: '45px',
                        border: `2px solid ${primaryVeryLight}`,
                        borderRadius: '12px',
                        padding: '14px 20px 14px 45px',
                      }}
                    />
                  </div>
                </div>

                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  <table className="table table-hover mb-0">
                    <thead style={{ backgroundColor: primaryVeryLight, position: 'sticky', top: 0, zIndex: 10 }}>
                      <tr>
                        <th style={{ padding: '16px', fontWeight: '700', color: primaryColor, border: 'none' }}>Item Name</th>
                        <th style={{ padding: '16px', fontWeight: '700', color: primaryColor, border: 'none' }}>Availability</th>
                        <th style={{ padding: '16px', fontWeight: '700', color: primaryColor, border: 'none' }}>Price</th>
                        <th style={{ padding: '16px', fontWeight: '700', color: primaryColor, border: 'none' }}>Qty</th>
                        <th style={{ padding: '16px', fontWeight: '700', color: primaryColor, border: 'none' }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredItems.length > 0 ? (
                        filteredItems.map((item, index) => (
                          <tr key={index} style={{ borderBottom: `1px solid ${primaryVeryLight}` }}>
                            <td style={{ padding: '16px' }}>
                              <div>
                                <div style={{ fontWeight: '600', color: '#212529' }}>{item.name}</div>
                                <small style={{ color: '#6c757d' }}>{item.barcode}</small>
                              </div>
                            </td>
                            <td style={{ padding: '16px' }}>
                              <Badge bg={item.availability === 'In Stock' ? 'success' : 'warning'} style={{ fontSize: '11px' }}>
                                {item.availability}
                              </Badge>
                            </td>
                            <td style={{ padding: '16px', fontWeight: '700', color: primaryColor }}>${item.price}</td>
                            <td style={{ padding: '16px' }}>
                              <input
                                type="number"
                                min="1"
                                defaultValue="1"
                                className="form-control"
                                style={{
                                  width: '80px',
                                  border: `1px solid ${primaryVeryLight}`,
                                  borderRadius: '6px',
                                  textAlign: 'center',
                                }}
                              />
                            </td>
                            <td style={{ padding: '16px' }}>
                              <button
                                className="btn btn-sm"
                                style={{
                                  backgroundColor: primaryColor,
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  padding: '8px 16px',
                                  fontWeight: '600',
                                }}
                              >
                                Add
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center" style={{ padding: '40px', color: '#6c757d' }}>
                            <FaBox size={32} color={primaryLight} className="mb-3" />
                            <div>No items found</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            background: primaryUltraLight,
            border: 'none',
            padding: '24px 32px',
          }}
        >
          <Button
            variant="light"
            onClick={handleClose}
            style={{
              border: `1px solid ${primaryVeryLight}`,
              borderRadius: '8px',
              padding: '12px 24px',
              fontWeight: '600',
            }}
          >
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: primaryColor,
              border: 'none',
              borderRadius: '8px',
              padding: '12px 24px',
              fontWeight: '600',
            }}
            disabled
          >
            Confirm Selection
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default CashierMenu;
